<template>
  <NuxtLink to="https://cre.ru/user/login" :class="$style.userControl">
    <Icon :class="$style.userControl__icon" name="my-icon:i-user" :size="24" />
  </NuxtLink>
</template>

<style module lang="scss">
.userControl {
  width: 64px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  &:hover &__icon {
    path {
      fill: var(--color-red-1);
    }
  }
}
</style>
